<template>
  <div>
    <h4 class="page-title text-center">
      {{ formType === 'new' ? title : 'UPDATE ' + title }}
    </h4>
    <p class="text-center">{{ subTitle }} {{ todayDate }}</p>
    <b-row>
      <b-col v-if="!isSubmitted" sm="12" lg="4">
        <b-button
          class="box-shadow2"
          @click="uploadDenominations"
          :variant="isDarkMode ? 'outline-success' : 'success'"
        >
          <font-awesome-icon :icon="['fas', 'upload']" class="mr-1" />Upload Denominations
        </b-button>
      </b-col>
      <b-col sm="12" lg="4">
        <h3 class="page-title text-center">Store Code: {{ storeid ? storeid : 'Test' }}</h3>
      </b-col>
      <b-col sm="12" lg="4">
        <h3 class="page-title text-center">Store Name: {{ storeName ? storeName : 'Test' }}</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <CashCertificateBox
          title="Main Cash"
          :items="mainCashItems"
          :isDarkMode="isDarkMode"
          :mainCash="mainDcCash"
          :difference="differenceDcCash"
          :remark="remarkDC"
          :isMainCashVisible="true"
          :isDifferenceVisible="true"
          :isRemarkVisible="true"
          :mainCashText="mainCashText"
          :isSubmitted="isSubmitted"
          :isValidRemark="validMainRemark"
          @update-total="updateGrandTotal"
          @update-remark="updateRemarkDC"
        />
      </b-col>
      <b-col>
        <CashCertificateBox
          title="Online Cash"
          :items="onlineCashItems"
          :isDarkMode="isDarkMode"
          :isMainCashVisible="false"
          :isDifferenceVisible="false"
          :isRemarkVisible="false"
          :isSubmitted="isSubmitted"
          @update-total="updateGrandTotal"
        />
      </b-col>
      <b-col v-if="isFloatCashVisible">
        <CashCertificateBox
          title="Float Cash"
          :items="floatCashItems"
          :isDarkMode="isDarkMode"
          :mainCash="mainFloatCash"
          :difference="differenceFloatCash"
          :isMainCashVisible="true"
          :isDifferenceVisible="true"
          :isRemarkVisible="false"
          :isSubmitted="isSubmitted"
          :mainCashText="'Float Cash as per system'"
          :differenceText="'Difference (Difference in float cash is not allowed)'"
          @update-total="updateGrandTotal"
        />
      </b-col>
      <b-col>
        <CashCertificateBox
          title="Petty Cash"
          :items="pettyCashItems"
          :isDarkMode="isDarkMode"
          :mainCash="mainPettyCash"
          :difference="differencePettyCash"
          :remark="remarkPettyCash"
          :isMainCashVisible="true"
          :isDifferenceVisible="true"
          :isRemarkVisible="true"
          :isSubmitted="isSubmitted"
          :isValidRemark="validPettyRemark"
          :mainCashText="'Petty cash as per system'"
          @update-total="updateGrandTotal"
          @update-remark="updateRemarkPettyCash"
        />
      </b-col>
    </b-row>
    <b-row v-if="isFinanceAdmin || isSsm" class="mt-3">
      <b-col>
        <div class="card container box-shadow2">
          <h3 class="text-center page-title">{{ confirmedTitle }}</h3>
          <b-table :items="confirmedCashItems" :fields="confirmedFields">
            <template #cell(designation)="data">
              {{ data.item.designation }}
            </template>
            <template #cell(name)="data">
              <b-form-input
                class="innerButton"
                v-model="data.item.name"
                :disabled="data.item.designation === 'Store Manager' || isFinanceAdmin || isSubmitted"
                @input="updateTlDmName(data.index, data.item.name)"
              ></b-form-input>
            </template>
            <template #cell(date)="data">
              {{ data.item.date }}
            </template>
          </b-table>
        </div>
      </b-col>
    </b-row>
    <div class="d-flex justify-content-center text-center mt-3">
      <div v-if="!isSubmitted && !isSsm">
        <b-button :variant="isDarkMode ? 'outline-success' : 'success'" @click="handleSubmit">
          {{ formType === 'new' ? 'SUBMIT CERTIFICATE' : 'UPDATE CERTIFICATE' }}</b-button
        >
      </div>
      <div class="ml-3" v-if="isSsm || isFinanceAdmin">
        <b-button :disabled="isSubmission" size="md" @click="handleApprove" variant="outline-success">Approve</b-button>
      </div>
      <div class="ml-3" v-if="isSsm || isFinanceAdmin">
        <b-button :disabled="isSubmission" size="md" @click="handleReject" variant="outline-danger">Reject</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';
import CashCertificateBox from '@/components/PettyCash/Certificate/CashCertificateBox.vue';
import csv from 'csvtojson';
import Vue from 'vue';

export default {
  name: 'PettyCashCertificateFormBox',
  components: {
    CashCertificateBox
  },
  props: {
    formType: String,
    isSubmission: Boolean,
    isSsmSubmitted: Boolean
  },
  data() {
    return {
      mainCashItems: this.initializeItems(),
      onlineCashItems: this.initializeItems(),
      floatCashItems: this.initializeItems(),
      pettyCashItems: this.initializeItems(),
      confirmedCashItems: this.initializeConfirmedItems(),
      confirmedFields: [
        { key: 'designation', label: 'Designation' },
        { key: 'name', label: 'Name' },
        { key: 'date', label: 'Date & Time' }
      ],
      title: 'SPENCER’S RETAIL LIMITED',
      confirmedTitle: 'Confirmed By',
      subTitle: 'STATEMENT OF PHYSICAL VERIFICATION OF MAIN CASH, PETTY CASH AND FLOAT CASH AS ON',
      todayDate: moment().format('DD-MM-YYYY'),
      storeid: null,
      storeName: '',
      company: null,
      grandTotal: {
        mainCashTotal: 0,
        onlineCashTotal: 0,
        floatCashTotal: 0,
        pettyCashTotal: 0
      },
      storeManagerName: '',
      mainDcCash: 0,
      mainOnlineCash: 0,
      mainFloatCash: 0,
      mainPettyCash: 0,
      differenceDcCash: 0,
      differenceOnlineCash: 0,
      differenceFloatCash: 0,
      differencePettyCash: 0,
      remarkDC: '',
      remarkOnline: '',
      remarkFloat: '',
      remarkPettyCash: '',
      quarter: this.getQuarter(),
      mainCashText: 'Main Cash as per the DC1 report (Actual)',
      isFinanceAdmin: false,
      isSsm: false,
      isAccountant: false,
      tlDmName: '',
      isSubmitted: false,
      validMainRemark: false,
      validPettyRemark: false,
      formData: {}
    };
  },
  methods: {
    ...mapActions('cstSubmission', ['getStoreByUser']),
    ...mapActions('pettyCash', ['getCashForCertificate', 'getCashOfOneCertificate']),
    initializeItems() {
      return [
        { denomination: 500, quantity: null },
        { denomination: 200, quantity: null },
        { denomination: 100, quantity: null },
        { denomination: 50, quantity: null },
        { denomination: 20, quantity: null },
        { denomination: 10, quantity: null },
        { denomination: 5, quantity: null },
        { denomination: 2, quantity: null },
        { denomination: 1, quantity: null }
      ];
    },
    convertDenominations(denominations) {
      return denominations.map(item => `${item.denomination}:::${item.quantity || 0}`);
    },
    reverseDenominations(denominations) {
      return denominations.map(item => {
        const [denomination, quantity] = item.split(':::');
        return { denomination: parseInt(denomination, 10), quantity: parseInt(quantity, 10) };
      });
    },
    initializeConfirmedItems() {
      return [
        { designation: 'Store Manager', name: '', date: moment().format('DD-MM-YYYY') },
        { designation: 'TL/DM', name: '', date: moment().format('DD-MM-YYYY') }
      ];
    },
    getQuarter() {
      const now = moment();
      const month = now.month();
      let quarter = 0;

      if (month >= 2 && month <= 5) {
        quarter = 1;
      } else if (month >= 6 && month <= 9) {
        quarter = 2;
      } else if (month >= 9 && month >= 0) {
        quarter = 3;
      } else {
        quarter = 4;
      }
      return quarter;
    },
    updateGrandTotal() {
      this.grandTotal = {
        mainCashTotal: this.mainCashItems.reduce((total, item) => total + (item.denomination * item.quantity || 0), 0),
        onlineCashTotal: this.onlineCashItems.reduce(
          (total, item) => total + (item.denomination * item.quantity || 0),
          0
        ),
        floatCashTotal: this.floatCashItems.reduce(
          (total, item) => total + (item.denomination * item.quantity || 0),
          0
        ),
        pettyCashTotal: this.pettyCashItems.reduce((total, item) => total + (item.denomination * item.quantity || 0), 0)
      };
      this.differenceDcCash = this.mainDcCash - this.grandTotal.mainCashTotal;
      this.differenceFloatCash = this.mainFloatCash - this.grandTotal.floatCashTotal;
      this.differencePettyCash = this.mainPettyCash - this.grandTotal.pettyCashTotal;
    },
    updateTitles() {
      if (this.user.company === 'CESC' || this.user.company === 'NBL') {
        this.title = this.company === 'CESC' ? 'CESC LIMITED' : 'NATURES BASKET LTD';
        this.subTitle = 'STATEMENT OF PHYSICAL VERIFICATION OF MAIN CASH, PETTY CASH AS ON';
      } else {
        this.title = 'SPENCER’S RETAIL LIMITED';
        this.subTitle = 'STATEMENT OF PHYSICAL VERIFICATION OF MAIN CASH, PETTY CASH AND FLOAT CASH AS ON';
      }
    },
    updateTlDmName(index, newName) {
      if (index === 1) {
        this.confirmedCashItems[index].name = newName;
        this.tlDmName = newName;
      }
    },
    createCsv() {
      let csv;
      if (this.user.company === 'NBL') {
        csv = `denomination,mainCashQty,onlineCashQty,pettyCashQty\n500,,\n200,,\n100,,\n50,,\n20,,\n10,,\n5,,\n2,,\n1,,\n`;
      } else {
        csv = `denomination,mainCashQty,onlineCashQty,floatCashQty,pettyCashQty\n500,,,\n200,,,\n100,,,\n50,,,\n20,,,\n10,,,\n5,,,\n2,,,\n1,,,\n`;
      }
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      anchor.target = '_blank';
      anchor.download = 'sampleCashFile.csv';
      anchor.click();
    },
    async uploadDenominations() {
      const result = await Vue.swal({
        title: 'Upload file for Denominations..',
        input: 'file',
        inputAttributes: {
          'aria-label': 'Upload your Denominations file in csv format'
        },
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Upload',
        denyButtonText: 'Download Sample',
        denyButtonColor: '#3a4',
        showCancelButton: true,
        showDenyButton: true,
        cancelButtonText: 'Close',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      });

      if (result.isDenied) {
        this.createCsv();
        return;
      }

      if (result.value) {
        const file = result.value;
        const reader = new FileReader();
        reader.onload = async () => {
          const csvString = reader.result;
          const data = await csv().fromString(csvString);
          this.updateCashItems(data);
        };
        reader.readAsText(file);
      }
    },
    updateCashItems(data) {
      data.forEach(row => {
        const denomination = parseInt(row.denomination);
        const mainCashQty = parseInt(row.mainCashQty) || null;
        const onlineCashQty = parseInt(row.onlineCashQty) || null;
        const pettyCashQty = parseInt(row.pettyCashQty) || null;

        const updateQuantity = (items, qty) => {
          const item = items.find(item => item.denomination === denomination);
          if (item) {
            item.quantity = qty;
          }
        };

        updateQuantity(this.mainCashItems, mainCashQty);
        updateQuantity(this.onlineCashItems, onlineCashQty);
        updateQuantity(this.pettyCashItems, pettyCashQty);

        if (this.user.company !== 'NBL') {
          const floatCashQty = parseInt(row.floatCashQty) || null;
          updateQuantity(this.floatCashItems, floatCashQty);
        }
      });

      this.updateGrandTotal();
    },
    updateRemarkDC(newRemark) {
      this.remarkDC = newRemark;
    },
    updateRemarkPettyCash(newRemark) {
      this.remarkPettyCash = newRemark;
    },
    setStoreManagerName() {
      this.confirmedCashItems[0].name = this.storeManagerName;
    },
    handleSubmit() {
      const hasValidDenomination =
        this.mainCashItems.some(item => item.quantity !== null) ||
        this.onlineCashItems.some(item => item.quantity !== null) ||
        this.pettyCashItems.some(item => item.quantity !== null);

      const hasValidDifference =
        this.differenceDcCash === 0 || this.differenceFloatCash === 0 || this.differencePettyCash === 0;

      const hasValidMainRemarks = this.remarkDC !== '' || !this.differenceDcCash < 0 || !this.differenceDcCash > 0;
      const hasValidPettyRemarks =
        this.remarkPettyCash !== '' || !this.differencePettyCash < 0 || !this.differencePettyCash > 0;
      if (!hasValidDenomination) {
        this.showValidationError('At least one denomination is required');
      } else if (!hasValidMainRemarks || !hasValidPettyRemarks) {
        !hasValidMainRemarks
          ? (this.validMainRemark = !this.validMainRemark)
          : //  this.showValidationError('Main Cash remarks is required')
          !hasValidPettyRemarks
          ? (this.validPettyRemark = !this.validPettyRemark)
          : // this.showValidationError('Petty Cash remarks is required')
            '';
      } else if (
        (!this.mainDcCash || !this.mainFloatCash || !this.mainPettyCash) &&
        (this.user.company === 'SRL' || this.user.company === 'CESC')
      ) {
        !this.mainDcCash
          ? this.showValidationError('Please ask Finance Admin to add Main cash first')
          : !this.mainFloatCash
          ? this.showValidationError('Please ask Finance Admin to add Float cash first')
          : this.showValidationError('Please ask Finance Admin to add Petty cash first');
      } else if ((!this.mainDcCash || !this.mainPettyCash) && this.user.company === 'NBL') {
        !this.mainDcCash
          ? this.showValidationError('Please ask Finance Admin to add Main cash first')
          : this.showValidationError('Please ask Finance Admin to add Petty cash first');
      } else {
        this.validMainRemark = !this.validMainRemark;
        this.validPettyRemark = !this.validPettyRemark;
        this.updateGrandTotal();

        this.formData = {
          company: this.user.company,
          storeid: this.storeid,
          storeName: this.storeName,
          quarter: this.quarter,
          isApprovedBySm: false,
          isApprovedByAdmin: false,
          currentStatus: 'CREATED',
          tlDmName: this.confirmedCashItems[1].name,
          mainCash: [
            {
              actualCash: this.mainDcCash,
              denomination: this.convertDenominations(this.mainCashItems),
              difference: this.differenceDcCash,
              remarks: this.remarkDC
            }
          ],
          onlineCash: [
            {
              actualCash: this.mainOnlineCash,
              denomination: this.convertDenominations(this.onlineCashItems),
              difference: 0,
              remarks: ''
            }
          ],
          floatCash: [
            {
              actualCash: this.mainFloatCash,
              denomination: this.convertDenominations(this.floatCashItems),
              difference: this.differenceFloatCash,
              remarks: ''
            }
          ],
          pettyCash: [
            {
              actualCash: this.mainPettyCash,
              denomination: this.convertDenominations(this.pettyCashItems),
              difference: this.differencePettyCash,
              remarks: this.remarkPettyCash
            }
          ]
        };
        if (this.formType === 'new') {
          this.$emit('add', this.formData);
        } else {
          this.isSubmitted = true;
          this.$emit('edit', this.formData);
        }
        return false;
      }
    },

    showValidationError(message) {
      Vue.swal({
        title: 'Validation Error',
        text: message,
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      });
    },
    handleApprove() {
      let row = {};
      if (!this.confirmedCashItems[1].name) {
        this.showValidationError('Please add TL/DL Name');
      } else {
        row = {
          company: this.user.company,
          storeid: this.storeid,
          storeName: this.storeName,
          quarter: this.quarter,
          currentStatus: this.isSsm ? 'PENDING' : 'APPROVED',
          isApprovedBySm: this.isSsm ? true : false,
          isApprovedByAdmin: this.isFinanceAdmin ? true : false,
          tlDmName: this.confirmedCashItems[1].name,
          mainCash: [
            {
              actualCash: this.mainDcCash,
              denomination: this.convertDenominations(this.mainCashItems),
              difference: this.differenceDcCash,
              remarks: this.remarkDC
            }
          ],
          onlineCash: [
            {
              actualCash: this.mainOnlineCash,
              denomination: this.convertDenominations(this.onlineCashItems),
              difference: 0,
              remarks: ''
            }
          ],
          floatCash: [
            {
              actualCash: this.mainFloatCash,
              denomination: this.convertDenominations(this.floatCashItems),
              difference: this.differenceFloatCash,
              remarks: ''
            }
          ],
          pettyCash: [
            {
              actualCash: this.mainPettyCash,
              denomination: this.convertDenominations(this.pettyCashItems),
              difference: this.differencePettyCash,
              remarks: this.remarkPettyCash
            }
          ]
        };
        Vue.swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this.",
          showCancelButton: true,
          confirmButtonColor: 'green',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Approve it!',
          preConfirm: () => {
            this.$emit('approve', { row });
          },
          background: this.isDarkMode ? '#464d54' : '#ffffff',
          customClass: {
            title: this.isDarkMode ? 'text-light' : 'text-dark',
            content: this.isDarkMode ? 'text-light' : 'text-dark'
          }
        });
      }
    },
    handleReject() {
      let row = {};
      if (!this.confirmedCashItems[1].name) {
        this.showValidationError('Please add TL/DL Name');
      } else {
        row = {
          company: this.user.company,
          storeid: this.storeid,
          storeName: this.storeName,
          quarter: this.quarter,
          isApprovedBySm: false,
          isApprovedByAdmin: false,
          currentStatus: 'REJECTED',
          tlDmName: this.confirmedCashItems[1].name,
          mainCash: [
            {
              actualCash: this.mainDcCash,
              denomination: this.convertDenominations(this.mainCashItems),
              difference: this.differenceDcCash,
              remarks: this.remarkDC
            }
          ],
          onlineCash: [
            {
              actualCash: this.mainOnlineCash,
              denomination: this.convertDenominations(this.onlineCashItems),
              difference: 0,
              remarks: ''
            }
          ],
          floatCash: [
            {
              actualCash: this.mainFloatCash,
              denomination: this.convertDenominations(this.floatCashItems),
              difference: this.differenceFloatCash,
              remarks: ''
            }
          ],
          pettyCash: [
            {
              actualCash: this.mainPettyCash,
              denomination: this.convertDenominations(this.pettyCashItems),
              difference: this.differencePettyCash,
              remarks: this.remarkPettyCash
            }
          ]
        };
        Vue.swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this.",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, reject it!',
          input: 'text',
          inputValue: '',
          preConfirm: inputValue => {
            if (inputValue) {
              row.rejectedRemarks = inputValue;
              this.$emit('reject', { row });
            }
          },
          background: this.isDarkMode ? '#464d54' : '#ffffff',
          customClass: {
            title: this.isDarkMode ? 'text-light' : 'text-dark',
            content: this.isDarkMode ? 'text-light' : 'text-dark'
          }
        });
      }
    }
  },
  computed: {
    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('auth', ['user']),
    ...mapState('cstSubmission', ['store']),
    ...mapState('pettyCash', ['cashDataForCertificate', 'cashCertificate']),
    metaDescription() {
      return this.formType === 'new' ? 'Add New Cash' : 'Update Cash';
    },
    isFloatCashVisible() {
      return this.user.company !== 'NBL';
    }
  },
  watch: {
    remarkDC(newVal) {
      if (!newVal) {
        this.validMainRemark = true;
      } else {
        this.validMainRemark = false;
      }
    },
    remarkPettyCash(newVal) {
      if (!newVal) {
        this.validPettyRemark = true;
      } else {
        this.validPettyRemark = false;
      }
    },
    store(newValue) {
      if (newValue && newValue.length > 0) {
        if (this.isAccountant) {
          newValue.map(item => {
            this.storeManagerName = item.storeManagerName;
            this.storeid = item.storeid;
            this.storeName = item.storeName;
          });
          this.setStoreManagerName();
          this.getCashForCertificate({
            company: this.company,
            storeid: this.storeid,
            quarter: this.quarter
          });
        } else if (this.isSsm) {
          newValue.map(item => {
            this.storeManagerName = item.storeManagerName;
          });
          this.setStoreManagerName();
          this.getCashForCertificate({
            company: this.company,
            storeid: this.storeid,
            quarter: this.quarter
          });
        } else {
          newValue.map(item => {
            if (item.storeid === this.storeid) {
              this.storeManagerName = item.storeManagerName;
            }
          });
          this.setStoreManagerName();
          this.getCashForCertificate({
            company: this.company,
            storeid: this.storeid,
            quarter: this.quarter
          });
        }
      }
    },
    cashCertificate(newValue) {
      if (newValue && Object.keys(newValue).length > 0) {
        // this.formData = newValue;
        if (this.isFinanceAdmin) {
          this.isSubmitted = true;
        }
        this.company = newValue.company;
        this.storeid = newValue.storeid;
        this.storeName = newValue.storeName;
        this.quarter = newValue.quarter;
        this.confirmedCashItems[1].name = newValue.tlDmName;
        if (newValue.mainCash.length > 0) {
          newValue.mainCash.map(item => {
            this.mainDcCash = parseInt(item.actualCash);
            this.mainCashItems = this.reverseDenominations(item.denomination);
            this.differenceDcCash = parseInt(item.difference);
            this.remarkDC = item.remarks;
          });
        }
        if (newValue.onlineCash.length > 0) {
          newValue.onlineCash.map(item => {
            this.mainOnlineCash = parseInt(item.actualCash);
            this.onlineCashItems = this.reverseDenominations(item.denomination);
            this.differenceOnlineCash = parseInt(item.difference);
            this.remarkOnline = item.remarks;
          });
        }
        if (newValue.floatCash.length > 0) {
          newValue.floatCash.map(item => {
            this.mainFloatCash = parseInt(item.actualCash);
            this.floatCashItems = this.reverseDenominations(item.denomination);
            this.differenceFloatCash = parseInt(item.difference);
            this.remarkFloat = item.remarks;
          });
        }
        if (newValue.pettyCash.length > 0) {
          newValue.pettyCash.map(item => {
            this.mainPettyCash = parseInt(item.actualCash);
            this.pettyCashItems = this.reverseDenominations(item.denomination);
            this.differencePettyCash = parseInt(item.difference);
            this.remarkPettyCash = item.remarks;
          });
        }
        if (newValue.currentStatus === 'REJECTED' && this.isAccountant) {
          this.isSubmitted = false;
          this.isSubmission = false;
        }
        if (newValue.currentStatus === 'CREATED' && this.isAccountant) {
          this.isSubmitted = true;
          this.isSubmission = true;
        }
        if (newValue.currentStatus === 'CREATED' && this.isSsm) {
          this.isSubmitted = false;
          this.isSubmission = false;
        }
        if (newValue.currentStatus === 'PENDING' && this.isSsm) {
          this.isSubmitted = true;
          this.isSubmission = true;
        }
        if (newValue.currentStatus === 'APPROVED') {
          this.isSubmission = true;
          this.isSubmitted = true;
        }
      }
    },
    cashDataForCertificate(newValue) {
      if (newValue.length > 0) {
        this.mainDcCash = parseFloat(newValue[0].mainCash);
        this.mainFloatCash = parseFloat(newValue[0].floatCash);
        this.mainPettyCash = parseFloat(newValue[0].pettyCash);
      }
    }
  },
  mounted() {
    this.company = this.user.company;
    this.updateTitles();
    this.getStoreByUser();
    if (this.$route.params.id) {
      this.getCashOfOneCertificate({ id: this.$route.params.id });
    }
    this.updateGrandTotal();
    if (this.user && this.user.roles) {
      this.user.roles.map(item => {
        if (item.name === 'FINANCE_ADMIN') {
          this.isFinanceAdmin = true;
        }
        if (item.name === 'ACCOUNTANT') {
          this.isAccountant = true;
        }
        if (item.name === 'STORE_SALES_MANAGER') {
          this.isSsm = true;
        }
      });
    }
  }
};
</script>

<style scoped></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
